import React, { Fragment } from "react";
import { useSignOut } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import auth from "../../../../FirebaseInit/FirebaseInit";
import Loading from "../../../Shear/Loading/Loading";
import profileIMG from "../../../../Assets/Images/Image/dashboard/profile.png";
const User = ({ data, index, setUpdate }) => {
  const [signOut, Sloading] = useSignOut(auth);
  const navigate = useNavigate();
  const makeAdminHandler = () => {
    fetch(`https://itghar-back.onrender.com/user/admin/${data?.email}`, {
      method: "PUT",

      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((response) => {
        if (response?.status === 401 || response?.status === 403) {
          localStorage.removeItem("accessToken");
          signOut();
          navigate("/");
        }

        return response.json();
      })
      .then((json) => {
        if (json?.status) {
          toast.success("SuccessFully Admin");
          setUpdate(true);
        } else {
          toast.error(json?.error);
        }
      });
  };

  if (Sloading) {
    return <Loading />;
  }
  return (
    <Fragment>
      <tbody>
        <tr>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <div className="flex">
              <div className="flex-shrink-0 w-10 h-10">
                <img
                  className="w-full h-full rounded-full"
                  src={data?.photo ? data?.photo : profileIMG}
                  alt="Global IT Master"
                />
              </div>
              <div className="ml-3">
                <p className="text-gray-900 whitespace-no-wrap">{data?.name}</p>
                <p className="text-gray-600 whitespace-no-wrap">{index + 1}</p>
              </div>
            </div>
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data?.email}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data?.role ? (
              <span> Already Admin</span>
            ) : (
              <button
                onClick={makeAdminHandler}
                className="bg-linear-gradient py-2 px-2 rounded-lg text-[#fff] text-sm font-semibold"
              >
                Make Admin
              </button>
            )}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <span className="relative inline-block px-3 py-1 font-semibold text-[red] cursor-pointer leading-tight">
              <span className="relative">Delete</span>
            </span>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export default User;
